{
  "Can i translate this ?": "Kann ich das übersetzen?",
  "Accounts": "Verbundene Konten",
  "Site settings": "Seiteneinstellungen",
  "Language": "Sprache",
  "Enable Marmaid": "Meerjungfrau aktivieren",
  "Enable Blur": "Weichzeichnen aktivieren",
  "Enable Animations": "Animationen aktivieren",
  "Personal information": "Persönliche Informationen",
  "NO": "Nein",
  "YES": "JA",
  "General": "Allgemein",
  "Profile": "Profil",
  "Notifications": "Benachrichtigungen",
  "Identity": "Identität",
  "Tokens": "Token",
  "Instances": "Instanzen",
  "Domains": "Domänen",
  "Sessions": "Sitzungen",
  "My Sessions": "Meine Sitzungen",
  "No projects": "Keine Projekte",
  "Create project": "Projekt erstellen",
  "Projects": "Projekte",
  "Project name": "Projektname",
  "Project description": "Projektbeschreibung",
  "Select team": "Team auswählen",
  "Set unique description for project": "Legen Sie eine eindeutige Beschreibung für das Projekt fest",
  "Please fill out this field.": "Bitte füllen Sie dieses Feld aus.",
  "Create": "Schaffen",
  "OwnedBy": "Gehört",
  "Open": "Offen",
  "Settings": "Einstellungen",
  "Apps": "Anwendungen",
  "Logout": "Ausloggen",
  "Admin": "Administrator",
  "Iot": "Iot",
  "Name": "Name",
  "Email": "Email",
  "You have being mentioned inside": "Du wurdest drinnen erwähnt",
  "from project": "aus Projekt",
  "by": "von",
  "You have being invited as member inside project": "Sie wurden als Mitglied innerhalb des Projekts eingeladen",
  "to build awesome things": "tolle Dinge zu bauen"
}